export function youtubeEmbedUrl(value) {
  try {
    const url = new URL(value);
    if (!["https:", "http:"].includes(url.protocol)) return null;
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    let id;
    if (host === "youtu.be") id = url.pathname.slice(1);
    else if (["youtube.com", "m.youtube.com"].includes(host)) {
      if (url.pathname === "/watch") id = url.searchParams.get("v");
      else if (/^\/(shorts|embed|live)\//.test(url.pathname)) id = url.pathname.split("/")[2];
    }
    return /^[a-zA-Z0-9_-]{11}$/.test(id || "") ? `https://www.youtube.com/embed/${id}?rel=0` : null;
  } catch { return null; }
}
export default function OutreachVideo({ url, title }) {
  const src = youtubeEmbedUrl(url);
  return src ? <iframe className="outreach-video" src={src} title={`Watch ${title}`} loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen /> : null;
}
